<span
  class="d-inline-block rounded-pill shadow-box bg-{{ bg }} text-{{
    text
  }} bold py-2 px-4 mb-3"
  [ngClass]="{ small: small }"
>
  <ng-content></ng-content>
</span>
